import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFunnelHasNearbyOrange = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 15,
	height: 16,
	viewBox: "0 0 15 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M13.6111 1.875H1.38841C0.650126 1.875 0.23997 2.75 0.704813 3.32422L5.76341 9.39453V11.9375C5.76341 12.1562 5.84544 12.375 6.03684 12.4844L8.22434 14.0156C8.33372 14.0977 8.47044 14.125 8.57981 14.125C8.93528 14.125 9.26341 13.8789 9.26341 13.4688V9.39453L14.2947 3.32422C14.7595 2.75 14.3493 1.875 13.6111 1.875ZM8.57981 8.84766L8.38841 9.09375V13.0586L6.63841 11.8281V9.09375L6.41966 8.84766L1.38841 2.75H13.6111L8.57981 8.84766Z",
			fill: "#E5743F"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 12.5,
			cy: 3,
			r: 2.5,
			fill: "#E5743F"
		})
	]
});
const ForwardRef = forwardRef(SvgFunnelHasNearbyOrange);
export { ForwardRef as ReactComponent };
